import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Card, CardBody, Input, Button, Table, FormGroup, Label, UncontrolledDropdown, DropdownToggle, DropdownMenu, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import queryString from 'query-string'
import moment from "moment";
import { toast } from 'react-toastify';
import { cloneDeep, filter, isEmpty, isNil, startsWith } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import noImage from '../../assets/images/users/no-img.jpg';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import { INVENTORY_SORT, PRODUCT_SORT, TRANG_THAI_BAN_HANG } from '../../constants/productStatus';
import InputTitleTop from '../../components/InputTitleTop';
import SelectTitleTop from '../../components/SelectTitleTop';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import NavTab from '../../components/NavTab';
import FileDownload from 'js-file-download'
import { baseUrl } from '../../constants/environment';
import { checkRole } from '../../helpers/Roles';
import IconPlus from '../../assets/images/icon-plus.png';
import IconSearch from '../../assets/images/icon-search.png';
import IconEdit from '../../assets/images/icon-edit.png';
import IconUserPlus from '../../assets/images/icon-user-plus.png';
import AsyncSelect from "react-select/async";
import styled from 'styled-components';


const configPage = {
    titlePage: 'Danh sách nhóm quyền',
    pathPage: '/setting/roles',
    column: 6,
}

const StatusList = [
    {
        value:"",
        label: "-Trạng thái-"
    },
    {
        value:0,
        label: "Ngưng hoạt động"
    },
    {
        value:1,
        label: "Đang hoạt động"
    },
]

interface Props {
    history: any,
    location: any,
    user: any,
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {}
}

const List: React.FC<Props> = (props: Props) => {
    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState({});
    const searchPrams = queryString.parse(props.location.search)

    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value
        }));
    }

    const setLimit = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            limit: value
        }));
    }

    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
            ...prevState,
            filter: value
        }));
    }

    useEffect(() => {
        document.title = configPage.titlePage
        getFilterParams()
        loadInit()
    }, []);

    useEffect(() => {
        loadData()
        setFilterParams({
            page:page,
            limit: limit,
            ...filter,
        });
    }, [filter, page, limit]);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const getFilterParams = () => {
        const newFilter: any = {}
        if (!isEmpty(searchPrams)) {
            Object.keys(searchPrams).map(function (key) {
                switch (key) {
                    case 'page':
                        setPage(Number(searchPrams[key]))
                        break;
                    case 'limit':
                        setLimit(Number(searchPrams[key]))
                        break;
                    default:
                        newFilter[key] = searchPrams[key]
                        break;
                }
            });
            setFilter(newFilter)
        }
    }

    const setFilterParams = (params: any) => {
        var filterParams = ''
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item]) filterParams = filterParams + '?' + item + '=' + params[item]
            } else {
                if (params[item]) filterParams = filterParams + '&' + item + '=' + params[item]

            }
        });
        props.history.push({
            search: filterParams
        })
    }

    const loadInit = async () => {
        
    }

    const loadData = async () => {
        setLoading(true);
        const formData = {
            page: page,
            limit: limit,
            ...filter,
        }
        if(formData?.name === "") {
            delete formData?.name
        }
        if(formData?.roles_id === "") {
            delete formData?.roles_id
        }
        if(formData?.usergroup_id === "") {
            delete formData?.usergroup_id
        }
        if(formData?.role_id === "") {
            delete formData?.role_id
        }
        const url = `${baseUrl}/roles`;
        let response: any = await APIClient.GET(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response.response?.data !== undefined) {
            setData(response?.response?.data)
            setTotalElements(response?.response?.total)
        }
    }

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: configPage.titlePage, active: true },
                ]}
                title={configPage.titlePage}
            />
            <PageBody>
                <DataFilter
                    filter={filter}
                    configPage={configPage}
                    setFilter={(filter: any) => setFilter(filter)}
                />
                <DataTableList
                    user={props?.user}
                    data={data} loading={loading}
                    page={page} limit={limit}
                    configPage={configPage}
                    history={props.history}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                <Pagination
                    link={configPage.pathPage + '/list'}
                    setPage={(page: number) => setPage(page)}
                    page={page}
                    limit={limit}
                    setLimit={(limit: number) => setLimit(limit)}
                    totalElements={totalElements}
                />
            </PageBody>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                <RenderActionModal {...props} closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>
            </ModalPopup>
        </React.Fragment>
    );
};

const DataTableList = (props: any) => {
    const { data, filter, loading, limit, page, configPage, handleActionModal} = props
    const start = limit * (page - 1)
    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th style={{ minWidth: 120 }}>Mã nhóm quyền</th>
                    <th style={{ minWidth: 120 }}>Tên nhóm quyền</th>
                    <th style={{ minWidth: 120 }}>Ngày tạo</th>
                    <th style={{ minWidth: 120 }}>Ngày cập nhật cuối</th>
                    <th className='text-center' style={{ minWidth: 120 }}>Số thành viên</th>
                    <th style={{ minWidth: 100 }} >Thao tác</th>
                </tr>
            </thead>
        )
    }
    const RenderBobyData = () => {
        const router = useHistory()
        if (loading) {
            return <RowLoading column={configPage.column} row={data.length || limit} />
        }
        if (data.length === 0) {
            return <RowEmpty column={configPage.column} title="Chưa có nhóm quyền nào!" />;
        }

        const gotoDetail = (item:any) => {
            router?.push(`/setting/roles/${item?.id}/view`)
        }
        const gotoUserList = (role:any, list:any,) => {
            props?.handleActionModal({type: 'viewListUser', data: {
                role:role,
                list: list
            } })
        }

        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => (
                        <tr key={`${item?.id}-${index}`}>
                            <td onClick={() => gotoDetail(item)}>{item?.code}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.name}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.created_time ? moment(item?.created_time).format('DD/MM/YYY') : '---'}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.updated_time ? moment(item?.updated_time).format('DD/MM/YYY') : '---'}</td>
                           
                            <td className='text-center' onClick={() => gotoUserList(item, item?.users)}><b className='text-info'>{item?.users?.length}</b></td>
                            <td>
                                <div className="table-action">
                                    <div className="button-nutri" onClick={() => router?.push(`/setting/roles/${item?.id}`)}><img style={{border: 'none'}} src={IconEdit} width={20} height={20} alt=""/></div>
                                    <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'delete', data: item})}><i className='uil-trash-alt'></i></div>
                                    <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'addUser', data: item})}><img style={{border: 'none'}} src={IconUserPlus} width={20} height={20} alt=""/></div>
                                </div>
                            </td>
                        </tr>
                ))}
            </tbody>
        )
    }

    return (
        <div>
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
            {loading && <Loader />}
        </div>
    );
};

const DataFilter = (props: any) => {
    const { setFilter, filter, roles, usergroup} = props
    const [name, setName] = useState(filter?.name);
    const timer = useRef<any>(null);

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            clearTimeout(timer.current)
            setFilter({
                ...filter,
                page: 1,
                name: e.target.value,
            })
        }
    }

    const handleChange = (e: any) => {
        clearTimeout(timer.current)
        const { name, value } = e?.target
        setFilter({
            ...filter,
            page: 1,
            [name]: value
        })
    }
    
    return (
        <Row className="mb-3 filter-custom">
            <Col xl={10}>
                <Row>
                    <Col xl={5}>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                                <img src={IconSearch} width={18} height={18} alt=""/>
                            </InputGroupAddon>
                            <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Theo tên nhóm quyền" />
                        </InputGroup>
                        {/* <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Mã nhóm quyền, Tên nhóm quyền " /> */}
                    </Col>
                    <Col xl={8}>
                        <Row>
                            {/* <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Trạng thái-"
                                    options={StatusList}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'status', value: value.value } })
                                    }}
                                    value={StatusList?.filter((option: any) => filter?.status === option.value)}
                                ></Select>
                            </Col> */}
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xl={2}>
                <div className="text-right">
                    <Link to={`${configPage.pathPage}/add`}><Button color="success" className="ml-2"><img className='mr-1' style={{border: 'none'}} src={IconPlus} width={20} height={20} alt=""/>  Thêm</Button></Link>
                </div>
            </Col>
        </Row>
    );
};

const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { closeModal, action, loadData } = props
    const [loadingStockUser, setLoadingStockUser] = useState(false);
    const [queryStockUser, setQueryStockUser] = useState('')
    const [data, setData] = useState(action?.data?.users)
    const [users, setUsers] = useState([])


    useEffect(() => {
        loadInit()
    }, []);

    useEffect(() => {
        const users = action?.data?.users?.reduce((prev:any, item:any)=>{
            prev = [...prev, {...item,
                value: item?.id,
                label:`${item?.code || ''} ${item?.name}`,
            }]
            return prev
        },[])
        setData(users)
    }, [action?.data?.users]);

    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 200,
        }
        const [
            responseUser,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/user`, {
                ...params,
            }),
        ]);
        if (responseUser.response?.data !== undefined) {
            let ListArr:any = [];
            responseUser.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label:`${e?.code || ''} ${e?.name}`,
                })
            })
            setUsers(ListArr)
        }
    }

    const handleInputChangeStockUser = (newValue:any) => {
        setQueryStockUser( newValue);
        return newValue;
    };

    const loadStockUser = async () => {
        setLoadingStockUser(true)
        let response: any = await APIClient.GET(`${baseUrl}/user`,{
            page: 1,
            limit: 100,
            name: queryStockUser
        });
        setLoadingStockUser(false)
        if (response.response?.data !== undefined) {
            const ListArr = response.response?.data?.reduce((prev:any, item:any)=>{
                prev = [...prev,
                    {
                        ...item,
                        label:`${item?.code || ''} ${item?.name}`,
                        value:item?.id
                    }
                ]
                return prev
            },[])
            return ListArr
        }else{
            return []
        }
    };

    const handleDelete = async() => {
        setLoading(true)
        const url = `${baseUrl}/roles/${action?.data?.id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xóa nhóm quyền thành công')
            closeModal();
            loadData()
        }
    }

    const handleUpdateRole = async() => {
        const newUsers = data?.reduce((prev:any, item:any)=> {
            if(item) prev = [...prev, item?.id]
            return prev
        },[])
        setLoading(true)
        const url = `${baseUrl}/roles/users/${action?.data?.id}`;
        const params = {
            users: newUsers,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Thêm thành viên vào nhóm quyền thành công')
            closeModal();
            loadData()
        }
    }

    if(!checkRole(props?.user?.roles, ['userEdit'], props?.user?.role)){
        return (
            <CardBody className='p-0' style={{width:460}}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                </div>
                {loading && <Loader />}
            </CardBody>
    
        )
    }

    return (
        <CardBody className='p-0' style={{width: action?.type === 'viewListUser' ? 750 : action?.type === 'addUser' ? 600 : 400}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    {
                        action?.type === 'delete' ? 'Xóa nhóm quyền'
                        :action?.type === 'addUser' ? 'Thêm thành viên vào nhóm quyền'
                        :action?.type === 'viewListUser' ? 'Thành viên'
                        :'Thông báo'
                    }
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className={`modal-body pb-2 ${action?.type === 'viewListUser' ? ' pt-0':' pt-2'}`}>
                <Col md={12}>
                    <FormGroup row className="label-only">
                        {action?.type === 'delete' &&
                        <>
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                Bạn có chắc chắn muốn xóa nhóm quyền <br/><b>{action?.data?.name}</b><br />
                            </p>
                        </>}
                        {action?.type === 'viewListUser' &&
                        <>
                            <p className="font-size-18 mt-2" style={{textAlign: 'left', width:'100%'}}>
                               <b>{action?.data?.role?.name}</b>
                            </p>
                            <div className="table-responsive">
                                <table className="mb-0 table-custom no-bg table table-input responsive" >
                                    <thead>
                                        <tr>
                                            <th className="text-center" style={{ width: '25%' }}>Mã nhân viên</th>
                                            <th className="text-center" style={{ width: '25%' }}>Tên nhân viên</th>
                                            <th className="text-center" style={{ width: '25%' }}>Số điện thoại</th>
                                            <th className="text-center" style={{ width: '25%' }}>Chức vụ</th>
                                        </tr>
                                    </thead>
                                    {(action?.data?.list?.length === 0 || !action?.data?.list) ?
                                        <RowEmpty column={4} title="Chưa có thành viên nào!" />:
                                        <tbody>
                                        {
                                            action?.data?.list?.map((item:any, index:number) => (
                                                <tr>
                                                    <td className="text-center">{item?.code}</td>
                                                    <td className="text-center">{item?.name}</td>
                                                    <td className="text-center">{item?.phone}</td>
                                                    <td className="text-center">{item?.usertitle_id?.name}</td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </>}
                        {action?.type === 'addUser' &&
                        <>
                            <Col md={12} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Nhóm quyền</Label>
                                    <ValueText className='only-view'>{action?.data?.name}</ValueText>
                                </FormGroup>
                            </Col>
                            <Col md={12} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Phân quyền</Label>
                                    <AsyncSelect
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        onInputChange={handleInputChangeStockUser}
                                        loadOptions={loadStockUser}
                                        inputValue={queryStockUser}
                                        placeholder={loadingStockUser ? "Đang tải dữ liệu..." : "Nhập tên, mã..."}
                                        noOptionsMessage={() => queryStockUser ? "Không tìm thấy dữ liệu" : 'Nhập tên, mã nhân viên'}
                                        loadingMessage={() => 'searching...'}
                                        styles={customStyles}
                                        cacheOptions
                                        defaultOptions={users}
                                        onChange={(val: any) => {
                                            setData(val)
                                        }}
                                        value={data}
                                        isMulti
                                    />
                                </FormGroup>
                            </Col>
                        </>
                        }
                    </FormGroup>
                </Col>
            </div>
            <div className="modal-footer">
                { action?.type !== 'viewListUser' &&
                <Button
                    onClick={()=>{
                        action?.type === 'delete' && handleDelete()
                        action?.type === 'addUser' && handleUpdateRole()
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
                }
            </div>
            {loading && <Loader />}
        </CardBody>

    )
}


const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const customStyles = {
    menuList: (base:any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
      }),
};

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(List)